<template>
  <div
    class="xls-toggle-wrap"
    :title="title"
    @click="$emit('update:modelValue', !modelValue)"
  >
    <div class="xls-toggle" :class="{ off: !modelValue }">
      <span class="txt">{{ modelValue ? "on" : "off" }}</span>
      <span class="knob"></span>
    </div>
    <span class="xls-label">XLS</span>
  </div>
</template>

<script>
export default {
  name: "XlsToggle",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Switch between XLS grid and default list view",
    },
  },
  emits: ["update:modelValue"],
};
</script>

<style scoped>
.xls-toggle-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}
.xls-toggle {
  width: 46px;
  height: 23px;
  border-radius: 12px;
  background: #2fbf5c;
  display: flex;
  align-items: center;
  padding: 0 3px;
  transition: background 0.18s;
  flex-shrink: 0;
}
.xls-toggle .txt {
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  margin-right: auto;
  padding-left: 2px;
  line-height: 1;
}
.xls-toggle .knob {
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background: #fff;
}
.xls-toggle.off {
  background: #c4c4c4;
  flex-direction: row-reverse;
}
.xls-toggle.off .txt {
  margin-right: 0;
  margin-left: auto;
  padding-left: 0;
  padding-right: 2px;
}
.xls-toggle-wrap .xls-label {
  font-size: 12px;
  color: #6e6e6e;
  font-weight: 500;
}
</style>
